import logoImage from '@assets/images/hypernova-logo.png';

interface LogoProps {
  className?: string;
  width?: number;
  height?: number;
  showText?: boolean;
  src?: string | null;
}

export function Logo({ className = '', width, height, showText = false, src }: LogoProps) {
  const logoSrc = src || logoImage;

  return (
    <div className={`flex items-center justify-center gap-3 ${className}`} data-testid="logo-container">
      <img
        src={logoSrc}
        alt="Facturación Electrónica"
        width={width}
        height={height}
        className="object-contain mx-auto"
        style={{ maxWidth: '100%', margin: '15px' }}
        onError={(e) => {
          (e.currentTarget as HTMLImageElement).src = logoImage;
        }}
        data-testid="logo-image"
      />
      {showText && (
        <span className="text-2xl font-bold text-primary-600">Facturación Electrónica</span>
      )}
    </div>
  );
}
